<template>
  <div class="floating-message-indicator" v-if="unreadCount > 0" @click="goToMessages">
    <ion-fab-button color="primary" size="small">
      <ion-icon :icon="mailOutline"></ion-icon>
    </ion-fab-button>
    
    <!-- Badge para mensajes no leídos -->
    <div class="badge">
      {{ displayCount }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { IonFabButton, IonIcon } from '@ionic/vue'
import { mailOutline } from 'ionicons/icons'
import { useRouter } from 'vue-router'
import { useUnreadMessages } from '@/composables/useUnreadMessages'

const router = useRouter()
const { unreadCount, startPolling, stopPolling } = useUnreadMessages()

// Mostrar hasta 99, después "99+"
const displayCount = computed(() => {
  return unreadCount.value > 99 ? '99+' : unreadCount.value.toString()
})

const goToMessages = () => {
  router.push('/mensajes')
}

onMounted(() => {
  startPolling(600000) // Polling cada 10 minutos
})

onUnmounted(() => {
  stopPolling()
})
</script>

<style scoped>
.floating-message-indicator {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  cursor: pointer;
}

.floating-message-indicator ion-fab-button {
  --size: 56px;
  --border-radius: 50%;
  --box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.floating-message-indicator ion-fab-button:hover {
  --box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  animation-play-state: paused; /* Pausa la animación al hacer hover */
  transform: translateY(-2px) !important;
  transition: all 0.3s ease;
}

.floating-message-indicator:hover .badge {
  animation-play-state: paused; /* Pausa también la animación del badge */
  transform: scale(1.05) !important;
}

.badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4444 !important;
  color: white !important;
  border-radius: 12px;
  min-width: 20px;
  height: 20px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  animation: badge-pulse 1.5s infinite ease-in-out;
}

@keyframes badge-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(255, 68, 68, 0.4);
  }
}

/* Efecto de rebote/vibración para llamar la atención */
.floating-message-indicator ion-fab-button {
  animation: bounce-shake 2.5s infinite ease-in-out;
}

@keyframes bounce-shake {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) translateX(0);
  }
  5% {
    transform: translateY(-6px) translateX(-1px);
  }
  10% {
    transform: translateY(-8px) translateX(1px);
  }
  15% {
    transform: translateY(-4px) translateX(-1px);
  }
  25% {
    transform: translateY(-2px) translateX(0);
  }
  30% {
    transform: translateY(-5px) translateX(1px);
  }
  35% {
    transform: translateY(-7px) translateX(-1px);
  }
  40% {
    transform: translateY(-3px) translateX(0);
  }
  60% {
    transform: translateY(-2px) translateX(1px);
  }
  70% {
    transform: translateY(-4px) translateX(-1px);
  }
  75% {
    transform: translateY(-2px) translateX(0);
  }
}

/* Animación de entrada */
.floating-message-indicator {
  animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive - ajustar posición en pantallas pequeñas */
@media (max-width: 768px) {
  .floating-message-indicator {
    bottom: 80px; /* Evitar conflicto con tab bar en móviles */
    right: 15px;
  }
}
</style>